let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("1MIK8")).then(() => parcelRequire('8ZHVH'));